export default __webpack_public_path__ + "static/media/audienceviewlogo.3d0d4e38.png";